
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/consult",
      function () {
        return require("private-next-pages/consult/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/consult"])
      });
    }
  